import { c as _c } from "react/compiler-runtime";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { Tooltip } from "react-tooltip";
import UserCICTypeIconTooltip from "./tooltip/UserCICTypeIconTooltip";
import UserCICTypeIcon from "./UserCICTypeIcon";
export default function UserCICTypeIconWrapper(t0) {
  const $ = _c(14);
  const {
    profile
  } = t0;
  const tooltipId = `user-cic-type-tooltip-${profile.id}`;
  let t1;
  if ($[0] !== profile.cic) {
    t1 = <UserCICTypeIcon cic={profile.cic} />;
    $[0] = profile.cic;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== tooltipId) {
    t2 = <div data-tooltip-id={tooltipId} className="tw-cursor-pointer">{t1}</div>;
    $[2] = t1;
    $[3] = tooltipId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      backgroundColor: "#26272B",
      borderRadius: "8px",
      padding: "0",
      maxWidth: "360px",
      zIndex: 9999
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== profile) {
    t4 = <UserCICTypeIconTooltip profile={profile} />;
    $[6] = profile;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4 || $[9] !== tooltipId) {
    t5 = <Tooltip id={tooltipId} clickable={true} place="right" opacity={1} border="1px solid #333" style={t3}>{t4}</Tooltip>;
    $[8] = t4;
    $[9] = tooltipId;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t5) {
    t6 = <>{t2}{t5}</>;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}